import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { errorMessage, successMessage } from '@api/messages';
import { postComment } from '../api';
import { CommentDTO } from '../dto/CommentDTO';

function usePostComment() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutate } = useMutation((comment: CommentDTO) => postComment(comment), {
    onSuccess: () => {
      queryClient.invalidateQueries('comments');
      queryClient.invalidateQueries('commentsCount');
      successMessage({
        title: t('success.saving.comment'),
        message: null,
      });
    },
    onError: error => {
      errorMessage({
        title: t('error.saving.comment'),
        message: null,
        error,
      });
    },
  });
  return mutate;
}

export default usePostComment;
